import React from "react";
import { QuestionnaireContext } from "..";

export const useQuestionareContext = () =>
  React.useContext(QuestionnaireContext);
